import { useState, useRef } from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import cn from "classnames";
import { object, string } from "yup";

import { Upload } from "../../ui-kit/upload/Upload";

import "./styles.scss";
import { constants } from "utilities/constants";
import { Modal } from "components/ui-kit/Modal/Modal";
import { Dropdown } from "components/ui-kit/Dropdown";
import { Input } from "components/ui-kit/Input";

const CustomRequestSchema = object({
  subject: string().required("Required field"),
  message: string().required("Required field"),
});

const { RequestTypes } = constants;

const CreateCustomRequestModal = ({
  closeModal,
  updateCategory,
  categories,
  traderIdsList,
  updateTraderIds,
  activeCategory,
  activeTraderIds,
  submitModal,
}) => {
  const formRef = useRef();
  const { loading } = useSelector((state) => state.utils);
  const [localAttachments, setLocalAttachments] = useState([]);
  const defaultCategory = categories.find(
    (category) => category.value === activeCategory.value
  );

  const defaultTraderId = activeTraderIds?.length === 1 ? activeTraderIds[0] : "";

  const formik = useFormik({
    initialValues: {
      subject: "",
      message: "",
    },
    validationSchema: CustomRequestSchema,
    onSubmit: (values) => {
      activeTraderIds.forEach((AT) => {

        const formData = new FormData();
  
        for (const file of localAttachments) {
          formData.append("attachments[]", file, file.name);
        }
  
        submitModal({
          body: {
            type: RequestTypes.INQUIRY,
            ext: {
              ...values,
            },
            formData,
          },
          type: RequestTypes.INQUIRY,
          isCustomForm: true,
          traderRef: AT,
        });
      })
    },
  });

  return (
    <div className="modal-window">
      <Modal
        className="custom-request-modal cabinet-modals"
        overlayClassName="request-overlay"
        styleType="zimtra-primary"
        isOpen={true}
        hideBlur
        hasCloseIcon={false}
        onClickOutside={closeModal}
      >
        <Modal.Header
          className="modal-inner-header"
          onClose={closeModal}
          title={<h2 className="zimtra-h2">New Request</h2>}
        />
        <Modal.Body className="modal-inner-body">
          <div className="d-flex align-items-top modal-row first">
            <div className="left-side">Category:</div>
            <div>
              <Dropdown
                options={categories}
                className="request-dropdown"
                defaultValue={defaultCategory.value}
                placeholder="Select category"
                onChange={updateCategory}
              />
            </div>
          </div>
          <div className="d-flex align-items-top modal-row">
            <div className="left-side">TraderID:</div>
            {activeTraderIds?.length > 1 ? (
              <div className="left-side">
                {activeTraderIds.join(", ")}
              </div>
            ) : (
              <div>
                <Dropdown
                  options={traderIdsList}
                  defaultValue={defaultTraderId}
                  className="request-dropdown select-category-dropdown"
                  placeholder="Select TraderID"
                  onChange={(value) => updateTraderIds([value])}
                />
              </div>
            )}
          </div>
          <hr />
          <form onSubmit={formik.handleSubmit} ref={formRef}>
            <div className="d-flex align-items-top modal-row">
              <div className="left-side">Subject:</div>
              <div className={cn({ "error-field": formik.errors.subject })}>
                <Input
                  variant="zimtra-primary"
                  placeholder="Write subject of your request"
                  maxLength={50}
                  labelClassName="cabinet-input"
                  size="short"
                  id="subject"
                  name="subject"
                  onChange={formik.handleChange}
                  value={formik.values.subject}
                />
                {formik.errors.subject ? (
                  <div className="error-text">{formik.errors.subject}</div>
                ) : null}
              </div>
            </div>

            <div className="d-flex align-items-top modal-row request-row">
              <div className="left-side">Request:</div>
              <div className={cn({ "error-field": formik.errors.message })}>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Describe your request"
                  maxLength="1500"
                  className="cabinet-textarea"
                  onChange={formik.handleChange}
                  value={formik.values.message}
                />
                {formik.errors.message ? (
                  <div className="error-text">{formik.errors.message}</div>
                ) : null}
              </div>
            </div>

            <div className="d-flex align-items-top upload-row">
              <Upload
                handleChange={(items) => setLocalAttachments(items)}
                tooltip={{
                  tooltipClassName: "upload-tooltip",
                  tooltipContentClassName: "upload-tooltip-content",
                  content: (
                    <span>
                      Max file size: 5 MB.
                      <br />
                      Max number of attachments: 5. <br />
                      Allowed filetypes:
                      <br />
                      <ul>
                        <li>text: PDF, CSV, XLS, XLSX, TXT</li>
                        <li>images: JPEG, JPG, PNG, GIF</li>
                        <li>video: MP4, MOV, WMV, AVI, FLV</li>
                      </ul>
                    </span>
                  ),
                }}
              />
            </div>
          </form>
          <hr />
        </Modal.Body>
        <Modal.Footer className="modal-inner-footer d-flex justify-content-center">
          <button
            className="main-button"
            disabled={loading || !formik.isValid || !formik.dirty}
            onClick={formik.handleSubmit}
          >
            Create
          </button>
          <button className="main-button cancel-button" onClick={closeModal}>
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreateCustomRequestModal;
